import { BREAKPOINTS, NAMESPACE } from "../constants";
export const breakpoint = (name) => ({ theme }) => {
    const value = theme[NAMESPACE].breakpoints[name];
    if (value === undefined) {
        console.error(`Breakpoint "${name}" is not defined in theme.breakpoints. Must be one of: [${Object.keys(BREAKPOINTS).join(", ")}]`);
    }
    return value;
};
